// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--cefeF","wave-animation":"_9e1425b4d3--wave-animation--X53g7","text-22":"_9e1425b4d3--text-22--Wwbx9","has-height":"_9e1425b4d3--has-height--CdQ98"};